/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import Slider from "react-slick";

const CommonSlider = ({ settings, children }) => {
    const internalSettings = {
        dots: true,
        infinite: false,
        arrows: false,
        speed: 1300,
        slidesToShow: 5,
        slidesToScroll: 1,
        ...settings,
    };

    return (
        <Slider {...internalSettings}>
            {children}
        </Slider>
    );
};

export default CommonSlider;
